import React, { useEffect, useState } from "react";
import { companyID } from "../../../auth";
import api from "../../../api/axios";
import { fetchCompanySubscription } from "../../../services/SubscriptionService";
import { decrypt } from "../../../utils/crypto";
import PlanConfigurationModal from "../../../components/PlanConfigurationModal";

const SubscriptionExpire = ({ isSubscriptionExpiredSoon = false }) => {
  const userRole = localStorage.getItem("employee_role") || 0;
  console.log("isSubscriptionExpiredSoon", isSubscriptionExpiredSoon);
  const isSubscriptionExpired = JSON.parse(
    localStorage.getItem("isSubscriptionExpired")
  );
  const expiredSubscriptionPlan =
    localStorage.getItem("expired_subscription") || null;

  const [selectedSubcriptionData, setSelectedSubscriptionData] = useState({});
  const [plans, setPlans] = useState([]);
  const [showModal, setShowModal] = useState(false);

  const fetchCompanySubscriptionDetails = async (subscription_id) => {
    const company_id = companyID();
    const subscription = await fetchCompanySubscription(
      company_id,
      subscription_id
    );
    if (subscription && subscription.length > 0) {
      setSelectedSubscriptionData(subscription[0]);
    }
  };
  const fetchPlans = async () => {
    try {
      const response = await api.get("plans");
      if (response.status === 200) {
        setPlans(response.data.data ?? []);
      }
    } catch (error) {
      console.error("Error fetching plans:", error);
    }
  };

  const handleCloseModal = () => {
    if (isSubscriptionExpired) {
      setShowModal(true);
    } else {
      setShowModal(false);
      setSelectedSubscriptionData({});
    }
  };
  useEffect(() => {
    if (
      (isSubscriptionExpired || isSubscriptionExpiredSoon) &&
      expiredSubscriptionPlan
    ) {
      setShowModal(true);
      const subscription_id = decrypt(expiredSubscriptionPlan);
      fetchCompanySubscriptionDetails(subscription_id);
      fetchPlans();
    }
  }, []);
  return (
    <>
      {showModal && userRole < 3 && (
        <PlanConfigurationModal
          show={showModal}
          onHide={handleCloseModal}
          plans={plans}
          selectedPlanId={selectedSubcriptionData?.plan_id}
          onPaymentSuccess={() => {
            setShowModal(false);
            setSelectedSubscriptionData({});
          }}
          modalType="renewal"
          currentPlan={selectedSubcriptionData}
        />
      )}
    </>
  );
};

export default SubscriptionExpire;
